import { ReactComponent as IconAdministratorOff } from "assets/images/side-menu/administrator-tasks-off.svg";
import { ReactComponent as IconAdministratorOn } from "assets/images/side-menu/administrator-tasks-on.svg";
import { ReactComponent as IconGroupOff } from "assets/images/side-menu/groups-off.svg";
import { ReactComponent as IconGroupOn } from "assets/images/side-menu/groups-on.svg";
import { ReactComponent as IconInterestsOff } from "assets/images/side-menu/interests-off.svg";
import { ReactComponent as IconInterestsOn } from "assets/images/side-menu/interests-on.svg";
import { ReactComponent as IconMembersOff } from "assets/images/side-menu/members-off.svg";
import { ReactComponent as IconMembersOn } from "assets/images/side-menu/members-on.svg";
import { ReactComponent as IconWorkingOutOff } from "assets/images/side-menu/members-working-out-off.svg";
import { ReactComponent as IconWorkingOutOn } from "assets/images/side-menu/members-working-out-on.svg";
import { ReactComponent as IconMessageOff } from "assets/images/side-menu/message-center-off.svg";
import { ReactComponent as IconMessageOn } from "assets/images/side-menu/message-center-on.svg";
import { ReactComponent as IconReportsOff } from "assets/images/side-menu/reports-off.svg";
import { ReactComponent as IconReportsOn } from "assets/images/side-menu/reports-on.svg";
import { ReactComponent as IconSettingsOff } from "assets/images/side-menu/settings-off.svg";
import { ReactComponent as IconSettingsOn } from "assets/images/side-menu/settings-on.svg";
import { ReactComponent as IconStaffOff } from "assets/images/side-menu/staff-off.svg";
import { ReactComponent as IconStaffOn } from "assets/images/side-menu/staff-on.svg";
import { ReactComponent as IconTCAOn } from "assets/images/side-menu/tca-on.svg";
import { ReactComponent as IconWorkoutTemplateOff } from "assets/images/side-menu/workout-template-off.svg";
import { ReactComponent as IconWorkoutTemplateOn } from "assets/images/side-menu/workout-template-on.svg";
import ymcaLogo from "assets/images/side-menu/ymca.png";

const navbarData = [
  {
    activeIcon: <img src={ymcaLogo} alt="The Coach Approach" />,
    badge: 0,
    inactiveIcon: <img src={ymcaLogo} alt="The Coach Approach" />,
    isOnlyAccessibleByTCA: true,
    link: "#",
    name: "The Coach Approach®",
    rightIcon: null,
    submenu: [
      {
        activeIcon: <IconMembersOn width={24} height={24} />,
        badge: 0,
        inactiveIcon: <IconMembersOff width={24} height={24} />,
        link: "/tca-members",
        name: "TCA Members",
        rightIcon: null,
      },
      {
        activeIcon: <IconReportsOn width={24} height={24} />,
        badge: 0,
        inactiveIcon: <IconReportsOff width={24} height={24} />,
        link: "/tca-reports",
        name: "TCA Reports",
      },
    ],
  },
  {
    activeIcon: <IconWorkingOutOn />,
    badge: 0,
    inactiveIcon: <IconWorkingOutOff />,
    link: "/members-working-out",
    name: "Members Working Out",
    rightIcon: null,
  },
  {
    activeIcon: <IconMembersOn width={24} height={24} />,
    badge: 0,
    inactiveIcon: <IconMembersOff width={24} height={24} />,
    link: "/members",
    name: "Members",
    rightIcon: null,
  },
  {
    activeIcon: <IconMessageOn />,
    badge: 0,
    inactiveIcon: <IconMessageOff />,
    link: "/message-center",
    name: "Message Center",
    rightIcon: null,
  },
  // {
  //   activeIcon: <IconGroupOn />,
  //   badge: 0,
  //   inactiveIcon: <IconGroupOff />,
  //   isOnlyAccessibleByAdmin: true,
  //   link: "/groups/",
  //   name: "Groups",
  //   rightIcon: null,
  // },
  //{
  //  activeIcon: <IconReportsOn />,
  //  badge: 0,
  //  inactiveIcon: <IconReportsOff />,
  //  link: "/reports/",
  //  name: "Reports",
  //  rightIcon: null,
  //},
  {
    activeIcon: <IconAdministratorOn width={24} height={24} />,
    badge: 0,
    inactiveIcon: <IconAdministratorOff width={24} height={24} />,
    isOnlyAccessibleByAdmin: true,
    link: "#",
    name: "Administrator Tasks",
    rightIcon: null,
    submenu: [
      {
        activeIcon: <IconStaffOn width={24} height={24} />,
        badge: 0,
        inactiveIcon: <IconStaffOff width={24} height={24} />,
        link: "/staffs",
        name: "Staff Accounts",
        rightIcon: null,
      },
      {
        activeIcon: <IconMembersOn width={24} height={24} />,
        badge: 0,
        inactiveIcon: <IconMembersOff width={24} height={24} />,
        link: "/member-tasks",
        name: "Member Tasks",
      },
      {
        activeIcon: <IconInterestsOn width={24} height={24} />,
        badge: 0,
        inactiveIcon: <IconInterestsOff width={24} height={24} />,
        link: "/interests",
        name: "Interests",
      },
      {
        activeIcon: <IconWorkoutTemplateOn width={24} height={24} />,
        badge: 0,
        inactiveIcon: <IconWorkoutTemplateOff width={24} height={24} />,
        link: "/workout-templates",
        name: "Workout Templates",
      },
      {
        activeIcon: <IconSettingsOn width={24} height={24} />,
        badge: 0,
        inactiveIcon: <IconSettingsOff width={24} height={24} />,
        link: "/facility-options",
        name: "Facility Options",
      },
    ],
  },
  // {
  //   name: "Version: 2023-03-24-02",
  // },
];

export default navbarData;
